import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-maintainence-page',
  templateUrl: './maintainence-page.component.html',
  styleUrl: './maintainence-page.component.css',
})
export class MaintainencePageComponent implements OnInit {
  displaypopup: boolean = true

  ngOnInit(): void {
    this.displaypopup = true
  }
}
